import { render } from "./RegistrationForm.vue?vue&type=template&id=5b3aceaa"
import script from "./RegistrationForm.vue?vue&type=script&lang=js"
export * from "./RegistrationForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/steve/Desktop/valet/rspremote/web/app/themes/rspremote/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__